module.exports = {
    flutter_redux: 'https://pub.dartlang.org/packages/flutter_redux',
    dart_redux: '',
    'Dart By Example': 'http://jpryan.me/dartbyexample/',
    'Elixir School': 'https://elixirschool.com/en/',
}


// WEBPACK FOOTER //
// ./data/thanks.js